/**
 * @desc 分页
 */
const URL = "/rantion-device";
import http, { updateResponse } from "@/http";
export type Response = defs.device.ResponseDto<
  defs.device.IPage<defs.device.FirmwareVersionResponseDto>
>;
export function request(
  params: API.device.firmwareVersion.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/firmwareVersion/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
